<template lang="pug">
  .background-ctn
    .background-shape(v-html='wave', v-bind:style='{transform: "rotate3d(0,0,1," + this.transform.rotate + "deg) scale3d(" + this.transform.scale.x + ", " + this.transform.scale.y + ", 1) translate3d(" + this.transform.translate.x + ", " + this.transform.translate.y + ", 0)"}')
</template>

<script>
  export default {
    props: ['transform'],
    data () {
      return {
        wave: require('@/assets/img/donauhof-seperator.svg')
      }
    }
  }
</script>

<style lang="scss">
  @import "~utils";
  .background-ctn {
    display: none;
    @include desktop {
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
      height: 106%;
      margin-top: -6%;
      padding-bottom: 6%;
      box-sizing: content-box;
      overflow: hidden;
      z-index: -9;
      transition: all .75s $easeInOut;
      display: block;
      min-height: 100vh;
      .background-shape {
        margin-top: 5%;
        transform-origin: top left;
        transform: rotate3d(0,0,1,45deg) scale3d(4, 4, 1) translate3d(-15%, -30%, 0);
        -webkit-backface-visibility: hidden;
        -webkit-perspective: 1000;
        transition: transform 2s $easeInOut;
        svg {
          backface-visibility: hidden;
          path {
            backface-visibility: hidden;
            perspective: 1000;
            stroke: $light-blue !important;
          }
        }
      }    
    }
  }
</style>



// WEBPACK FOOTER //
// Background.vue?7ebb6d70